import React, { useEffect, useState } from "react";
import { MenuItem, TextField } from "@mui/material";

const DropDownListComponent = (props: any) => {
  const [optionValue, setOptionValue] = useState<any>('');

  useEffect(() => {
    if (props.model == null) {

      if (props.type === 'bool') {
        setOptionValue(props.optionValueSelected == 1);
        return;
      }

      setOptionValue(props.optionValueSelected ?? '');
      return;
    }

    let modelAnonima: any = props.model;
    if (props.model == null || modelAnonima['id'] == null || modelAnonima['id'] === '' || JSON.stringify(props.options) === JSON.stringify([])) {
      setOptionValue('');
      return;
    }

    let opt = modelAnonima[props.modelField] ?? '';

    if (JSON.stringify(opt) == JSON.stringify(optionValue)) {
      return;
    }

    if (props.type ==='bool') {
      setOptionValue(opt === 1);
      return;
    }

    setOptionValue(opt);
  }, [props.options, props.model]);

  function setModelEvent(newOptionValue: any) {
    let value = newOptionValue.target.value;
    setOptionValue(value);
    
    if (props.model == null) {
      setValueEventCallBack(value);
      return;
    }

    let modelAnonima: any = props.model;
    modelAnonima[props.modelField] = value;
    if (props.modelFieldName != null) {
      modelAnonima[props.modelFieldName] = newOptionValue == null ? '' : props.options.filter((x: any) => x.id === value)[0][props.textField];
    }
    
    setValueEventCallBack(value);
  }

  function setValueEventCallBack(value: any) {
    if (props.setValueEventCallBack != null) {
      props.setValueEventCallBack(value);
    }
  }

  return (
    <div className={props.divClassName}>
      <TextField
        fullWidth
        select
        required={props.required}
        label={props.label}
        onChange={(opt: any) => setModelEvent(opt)}
        defaultValue={null}
        value={optionValue ?? ''}>
        <MenuItem value="">
          <em>Selecione...</em>
        </MenuItem>
        {props.options.map((opt: any) => (
          <MenuItem key={opt[props.valueField]} value={opt[props.valueField]}>
            {opt[props.textField] ?? ''}
          </MenuItem>
        ))}
      </TextField>
    </div>
  )
}

export default DropDownListComponent;